var $22a134dea3c30fc7$exports = {};
$22a134dea3c30fc7$exports = {
    "maximum": `Maksimaalne`,
    "minimum": `Minimaalne`
};


export {$22a134dea3c30fc7$exports as default};
//# sourceMappingURL=et-EE.mjs.map
